<div class="maintenance-container">
  <img src="assets/generalImage/404_error.svg" alt="mascot" />
  <h1 [innerHTML]="contentDesc | translate"></h1>
  <app-button [textButton]="true" [buttonName]="'button.refresh'" (click)="reload()" class="submit-btn"></app-button>
</div>